<template>
  <div class="page">
    <LoadingBox v-if="isLoading" />

    <div class="header">
      <div class="header__content">
        <img class="header__picture" :src="user.avatar" />

        <div class="header__text">
          <h1 class="header__title">{{ user.name }}</h1>
          <h2 class="header__role">Especialista</h2>
          <p class="header__description">{{ user.teacher_description }}</p>
        </div>
      </div>
    </div>

    <div class="content">
        <div class="container">
          <h2 class="content__title">{{ user.name }} idealizou {{ user.courses_count }} curso<span v-if="user.courses_count > 1">s</span></h2>

          <CoursesList
            :courses="courses"
            :is-busy="isBusy"
            @next="fetchCourses"
          />
        </div>
    </div>
  </div>
</template>

<script>
  import { getAuthorById, getAuthorCourses } from '@/api/user.api'
  import LoadingBox from '@/components/layout/LoadingBox'
  import CoursesList from '@/components/course/CoursesList'

  export default {
    components: {
      LoadingBox,
      CoursesList,
    },

    metaInfo () {
      return {
        title: this.user.id
               ? `Cursos idealizados por ${this.user.name} | CyberClass`
               : null,
        meta: [
          {
            property: 'description', content: this.user.id && this.courses.length
                       ? `Conheça os cursos idealizados por ${this.user.name} no CyberClass como ${this.coursesSummary}`
                       : null
          }
        ]
      }
    },

    data: () => ({
      user: {},
      coursesPage: 1,
      courses: [],
      isLoading: false,
      isLastPage: false
    }),

    async mounted () {
      this.isLoading = true
      
      try {
        await this.fetchAuthor()
        await this.fetchCourses()
      } catch (err) {
        this.$router.replace({ name: 'home' })
      }
      
      this.isLoading = false
    },

    computed: {
      id () {
        return this.$route.params.id
      },

      isBusy () {
        return this.isLoading || this.isLastPage
      },

      coursesSummary () {
        return this.courses.slice(0, 3).map(course => course.name).join(', ')
      }
    },

    methods: {
      async fetchCourses () {
        const res = await getAuthorCourses(this.id, this.coursesPage++)

        res.data.map(course => this.courses.push(course))
        this.isLastPage = !res.links.next
      },

      async fetchAuthor () {
        this.user = await getAuthorById(this.id)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .page { position: relative }
  
  .content {
    padding: 40px 0;

    &__title {
      position: relative;
      padding-left: 1rem;
      font-size: 1.75rem;
      margin-bottom: 1.75rem;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        background: linear-gradient(158deg, $highlightPrimaryColor 4.86%, $red100 52.82%, $purple200 100.77%);
      }
    }
  }

  .header {
    display: flex;
    justify-content: center;
    padding: 60px 15px;
    background: $purple20;

    &__content {
      max-width: 950px;
      display: flex;
      align-items: center;
    }

    &__picture {
      width: 9.375rem;
      height: 9.375rem;
      border: 3px solid $purple100;
      border-radius: 100%;
    }

    &__text {
      padding-left: 1.25rem;
    }

    &__title {
      font-size: 1.625rem;
      font-weight: 700;
      font-family: $textSecondaryFamily;
    }

    &__role {
      font-size: 1.375rem;
    }

    &__description {
      margin-top: 15px;
    }
  }

  @media (max-width: 550px) {
      .header {
        &__content { flex-direction: column; }

        &__text { padding-left: 0 }

        &__picture { margin-bottom: 15px }
      }
    }
</style>